// extracted by mini-css-extract-plugin
export default {"labelContent":"labelContent--iiEk9"};